export enum ReportingGridRouteKey {
  loadSupportingTableGrid = 'loadSupportingTableGrid',
  mutateSupportingTableRow = 'mutateSupportingTableRow',
  loadProductsGrid = 'loadProductsGrid',
  mutateProductsRow = 'mutateProductsRow',
  loadMasterPaidGrid = 'loadMasterPaidGrid',
  mutateMasterPaidRow = 'mutateMasterPaidRow',
  loadMasterSubmitGrid = 'loadMasterSubmitGrid',
  mutateMasterSubmitRow = 'mutateMasterSubmitRow',
  loadReportingImportInvalidRows = 'loadReportingImportInvalidRows',
  mutateReportingImportInvalidRow = 'mutateReportingImportInvalidRow',
  loadReportingImportNormalizationIssues = 'loadReportingImportNormalizationIssues',
  mutateReportingImportNormalizationIssue = 'mutateReportingImportNormalizationIssue',
  searchReportingImportNormalizationResolutionOptions = 'searchReportingImportNormalizationResolutionOptions',
  applyNormalizationResolution = 'applyNormalizationResolution',
  rerunReportingImportNormalization = 'rerunReportingImportNormalization',
  loadReportingImportNormalizationStepQuality = 'loadReportingImportNormalizationStepQuality',
}

export enum ReportingImportRouteKey {
  downloadReportingImportSubmitFile = 'downloadReportingImportSubmitFile',
}
